import { render, staticRenderFns } from "./SelectedExamObject.vue?vue&type=template&id=104e8f83&scoped=true&"
import script from "./SelectedExamObject.vue?vue&type=script&lang=js&"
export * from "./SelectedExamObject.vue?vue&type=script&lang=js&"
import style0 from "./SelectedExamObject.vue?vue&type=style&index=0&id=104e8f83&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "104e8f83",
  null
  
)

export default component.exports